import styled from 'styled-components';

export const PageContainer = styled.div`
    padding: 12px;
    background: #ffffff;
    min-height: calc(100vh - 50px);
    box-sizing: border-box;
`;

export const DesktopShell = styled.div`
    border: 1px solid #028322;
    background: #ffffff;
`;

export const HeaderCard = styled.div`
    background: #ffffff;
    border-bottom: 1px solid #028322;
    padding: 12px;
`;

export const HeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
`;

export const Title = styled.h1`
    margin: 0;
    color: #028322;
    font-size: 1.05rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.02em;
`;

export const Subtitle = styled.p`
    margin: 6px 0 0 0;
    color: #25422f;
    font-size: 0.8rem;
`;

export const QueryPill = styled.span`
    background: #028322;
    color: #ffffff;
    border: 1px solid #028322;
    border-radius: 0;
    padding: 4px 8px;
    font-size: 0.72rem;
    font-weight: 600;
`;

export const StatsGrid = styled.div`
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 6px;
`;

export const StatCard = styled.div`
    border: 1px solid #028322;
    background: #ffffff;
    padding: 8px 10px;
`;

export const StatLabel = styled.p`
    margin: 0;
    color: #2f4f39;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
`;

export const StatValue = styled.p`
    margin: 4px 0 0 0;
    color: #028322;
    font-size: 1rem;
    font-weight: 700;
`;

export const Toolbar = styled.div`
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
`;

export const ToolbarFilters = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
`;

export const FilterInput = styled.input`
    min-width: 280px;
    width: 380px;
    max-width: 100%;
    height: 34px;
    border: 1px solid #028322;
    border-radius: 0;
    background: #ffffff;
    padding: 0 10px;
    box-sizing: border-box;
    color: #1d3a28;
    font-size: 0.8rem;

    &:focus {
        outline: none;
        border-color: #028322;
    }
`;

export const ToolbarActions = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const InlineLabel = styled.span`
    color: #2f5c40;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.02em;
`;

export const RangeInput = styled.input`
    width: 116px;
    height: 32px;
    border: 1px solid #028322;
    border-radius: 0;
    background: #ffffff;
    padding: 0 8px;
    box-sizing: border-box;
    color: #1d3a28;
    font-size: 0.74rem;

    &:focus {
        outline: none;
        border-color: #028322;
    }
`;

export const SortSelect = styled.select`
    height: 32px;
    border: 1px solid #028322;
    border-radius: 0;
    background: #ffffff;
    padding: 0 8px;
    box-sizing: border-box;
    color: #1d3a28;
    font-size: 0.74rem;
`;

export const SecondaryButton = styled.button`
    border: 1px solid #028322;
    background: #ffffff;
    color: #028322;
    border-radius: 0;
    height: 32px;
    padding: 0 10px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 0.72rem;
    font-weight: 600;

    &:hover {
        background: #f3fbf5;
    }

    &:disabled {
        opacity: 0.55;
        cursor: default;
    }
`;

export const TableCard = styled.div`
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    background: #ffffff;
`;

export const TableScroller = styled.div`
    width: 100%;
    overflow: auto;
`;

export const EnterpriseTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 980px;
    table-layout: auto;
`;

export const TableHead = styled.thead`
    background: #028322;
    color: #ffffff;
`;

export const TableHeadCell = styled.th`
    padding: 9px 10px;
    text-align: left;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 700;
    border-right: 1px solid #047a21;

    &:last-child {
        border-right: 0;
    }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    border-bottom: 1px solid #d7ebdc;

    &:nth-child(even) {
        background: #ffffff;
    }

    &:hover {
        background: #f3fbf5;
    }
`;

export const TableCell = styled.td`
    padding: 8px 10px;
    vertical-align: middle;
    color: #173523;
    font-size: 0.78rem;
    border-right: 1px solid #e3f2e6;

    &:last-child {
        border-right: 0;
    }
`;

export const ProductWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ProductImage = styled.img`
    width: 34px;
    height: 34px;
    border-radius: 0;
    object-fit: cover;
    border: 1px solid #028322;
    background: #ffffff;
`;

export const ProductMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
`;

export const ProductName = styled.p`
    margin: 0;
    color: #0f2b1c;
    font-weight: 600;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
`;

export const ProductHint = styled.p`
    margin: 0;
    color: #2b5b3f;
    font-size: 0.66rem;
`;

export const StockPill = styled.span`
    display: inline-flex;
    min-width: 42px;
    justify-content: center;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 0;
    font-size: 0.68rem;
    font-weight: 700;
    border: 1px solid #028322;
    background: ${({ tone }) => (tone === 'success' ? '#028322' : '#ffffff')};
    color: ${({ tone }) => (tone === 'success' ? '#ffffff' : '#028322')};
`;

export const StockEditWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const StockInput = styled.input`
    width: 84px;
    height: 30px;
    border: 1px solid #028322;
    border-radius: 0;
    background: #ffffff;
    padding: 0 8px;
    box-sizing: border-box;
    font-size: 0.78rem;
    color: #173523;

    &:focus {
        outline: none;
        border-color: #028322;
    }
`;

export const ActionGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
`;

export const ActionButton = styled.button`
    border-radius: 0;
    border: 1px solid #028322;
    background: ${({ tone }) => (tone === 'success' ? '#028322' : '#ffffff')};
    color: ${({ tone }) => (tone === 'success' ? '#ffffff' : '#028322')};
    font-size: 0.68rem;
    font-weight: 700;
    height: 28px;
    padding: 0 8px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    &:hover {
        background: ${({ tone }) => (tone === 'success' ? '#026d1c' : '#f3fbf5')};
    }

    &:disabled {
        opacity: 0.55;
        cursor: default;
    }
`;

export const EmptyState = styled.div`
    border-top: 1px solid #028322;
    padding: 22px 16px;
    text-align: center;
    color: #2f5c40;
    font-size: 0.82rem;
    background: #ffffff;
`;

export const LoadingOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(2, 131, 34, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 150;
`;

export const LoadingCard = styled.div`
    background: #ffffff;
    border: 1px solid #028322;
    border-radius: 0;
    padding: 20px;
`;
